import fetch, { NewAxiosRequestConfig } from '@/utils/axios';

import {
  CombineCheckoutV4Params,
  ICheckoutPre,
  IClearCartUnavailable,
  INoCartCheckoutPre,
  IVirtualPay,
  VirtualParams
} from '@/types/checkout.d';
import { ShopMoreType } from '@/types/product';
import * as T from '../types/so';
import { IDealPay } from '@/types/dealpay';
import { FloatingCartResponse } from '../types/so';

export const getSimpleInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/so/porder/simple', params, config);
};

/**
 * 商品增删改 -非 购物车页面
 * @param items
 * @param config
 */
export const purchaseNormalV3 = (items: T.PerchaseItemReq[], config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.put('/ec/so/porder/items/v3', items, config);
};

/**
 * 商品增删改 -非 购物车页面
 * @param items
 * @param config
 */
export const purchaseNormal = (items: T.PerchaseItemReq[], config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.put('/ec/so/porder/items/v2', items, config);
};

/**
 * 商品增删改 -购物车页面
 * @param items
 * @param config
 */
export const purchaseInCart = (items: T.PerchaseItemReq[], config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.put('/ec/so/porder/items/cart/v2', items, config);
};

/**
 * 商品增删改 -v3
 * @param items
 * @param config
 */
export const purchaseInCartV3 = (items: T.PerchaseItemReq[], config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.put('/ec/so/porder/items/cart/v3', items, config);
};

/**
 * 废弃
 * 通用商品的加购处理, 非 hotdish
 * @param items 商品数组
 * @param config ctx
 * @returns Promise
 */
// export const purchaseCommon = (items: T.PerchaseItemReq[], config?: NewAxiosRequestConfig): Promise<AResponse> => {
//   return fetch.put('/ec/so/porder/items', items, config);
// };

/**
 * 创建porder
 * @param params
 */
export const createPOrder = (zipcode: string): Promise<AResponse> => {
  return fetch.post('/ec/so/porder', { zipcode: zipcode, zipcode_type: 'manual' });
};

/**
 * 切换配送日期
 *
 * @param deliveryDate 配送日期
 * @param force 是否直接强制删除购物车失效商品，设置为true时不会返回失效商品
 * @param type 1=列表页, 2=详情页, 3=(具体作用不详)
 * @param venderId
 * @param config
 */
export const changeDeliveryDate = (
  deliveryDate: string,
  force: boolean,
  type: number,
  venderId: number,
  /**波次相关参数 */
  dealId?: number,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.put(
    '/ec/so/porder/hotdish/date',
    {
      delivery_pickup_date: deliveryDate,
      force: force,
      type: type,
      vendor_id: venderId,
      deal_id: dealId
    },
    config
  );
};

export const getBoughtBefore = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/recommend/bought/simple', params || {}, config);
};

/**
 * 获取配送日期
 * @param show_delivery_time checkout time
 * @param vendor_id checkout hotdish
 */
export type getDeliveryDateParams = {
  show_delivery_time?: boolean;
  vendor_id?: string;
  type?: string;
  is_filter_pre?: boolean;
};
export const getDeliveryDate = (params?: getDeliveryDateParams, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/so/delivery_date', params, config);
};

/**
 * 查询指定商品可售卖日期
 */
export const getDeliveryDateByItem = (product_id: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v5/items/delivery_date`, { product_id }, config);
};

/**
 * 切换配送日期
 * @param deliveryDate 配送日期
 * @param force 是否强制
 */
export const changeDeliveryDateHome = (
  params?: { [key: string]: any },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.put('/ec/so/porder/date', params, config);
};

/**
 * checkout 切换hotdish配送日期
 * @param params
 * @param config
 */
export const changeHotdishDeliveryDate = (
  params?: { [key: string]: any },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.put('/ec/so/porder/hotdish/date', params, config);
};

/**
 * 更新porder zipcode
 * @param params
 * @param config
 */
export type updatePOrderZipcodeParams = {
  zipcode?: string;
  address_id?: number;
};
export const updatePOrderZipcode = (
  params: updatePOrderZipcodeParams,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.put('/ec/so/porder/zipcode', params, config);
};

/* 查询购物车 mail order/ active V3
 * @param
 */
export const getCartData = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/so/porder/v3', params, config);
};

/* 查询购物车 mail order/ active V5
 * @param
 */
export const getCartDataV5 = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/so/porder/v5', params, config);
};

/* 购物车商品勾选
 * @param
 */
export const setCartSelect = (
  params?: {
    cart_domain: string;
    selected_product_keys?: string[];
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post('/ec/so/porder/items/select', params, config);
};

/* 购物车清除失效商家 /vendor/clear
 * @param
 */
export const clearCartUnavailableRestaurant = (params?: {
  vendor_ids: string[];
}): Promise<AResponse<IClearCartUnavailable>> => {
  return fetch.post('/ec/so/porder/vendor/clear', params);
};

// save for later 商品查询
export const getSave4later = (
  params: {
    offset: number;
    page_size: number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/so/save4later/v2', params, config);
};

// save for later 商品删除
export const deleteSave4later = (params: { product_keys: string[] }): Promise<AResponse> => {
  return fetch.delete(`/ec/so/save4later`, { data: params });
};

// save for later move to cart
export const moveSave4later = (params: { product_keys: string[] }): Promise<AResponse> => {
  return fetch.post('/ec/so/save4later/to_cart', params);
};

// save for later add
export const addSave4later = (params: { product_keys: string[] }): Promise<AResponse> => {
  return fetch.post('/ec/so/save4later/from_cart', params);
};

/**
 * @param params 获取checkout pre v2的信息
 * @param config
 */
export const getCheckoutInfoV2 = (
  params?: {
    cart_domain: 'grocery' | 'addon';
    tip_option?: boolean;
    plan_id?: number;
    delivery_window_id?: number | string;
    payment_routing?: string;
  },
  config?
): Promise<AResponse<IDealPay>> => {
  return fetch.post('/ec/so/order/checkout/pre/v2', params, config);
};

/**
 * @param params 获取upsell的信息
 */
export const getUpsellInfoV2 = (params: { cart_domain: 'grocery' | 'addon' }, config?): Promise<AResponse> => {
  return fetch.get(`/ec/item/v5/checkout/upsell/v2`, params, config);
};

/**
 * CHECKOUT结算
 * @param params
 */
export const checkout = (params: {
  type: string;
  referral_id: number;
  deal_id: number;
  delivery_time_id?: number;
  vendor_id?: number;
  tip: number;
  is_pick_up?: string | boolean;
  cvv_token?: string;
  order_note?: string;
  radar_options?: { session: string };
  braintree_device_data?: string;
}): Promise<AResponse> => {
  return fetch.post('/ec/so/order/checkout', {
    ...params,
    page_time: new Date().getTime()
  });
};

/**
 *
 * @param params 合并结算 v4
 * @returns
 */
export const combineCheckoutV4 = (params: CombineCheckoutV4Params): Promise<AResponse> => {
  return fetch.post('/ec/so/order/checkout/v4', params);
};

/**
 * 虚拟结算支付接口 (mainly for points & group-ponts &  gift card)
 * @param params
 * @returns
 */
export const virtualPay = (params: {
  product_type: string;
  deal_id?: number;
  items: VirtualParams[];
  member_share_id?: number;
  page_time?: number;
  points?: number;
  gl_tag?: number;
  phone?: string;
  payment_category?: string;
  email?: string;
  referral_id?: number;
  is_pick_up?: string | boolean;
  group_invite_id?: number;
}): Promise<AResponse<IVirtualPay>> => {
  return fetch.post('/ec/so/order/nocart/checkout', params);
};

/**
 * 虚拟结算支付接口 (mainly for points & group-ponts &  gift card)
 * @param params
 * @returns
 */
export const virtualPayV2 = (params: {
  product_type: string;
  deal_id?: number;
  items: VirtualParams[];
  member_share_id?: number;
  page_time?: number;
  points?: number;
  gl_tag?: number;
  phone?: string;
  payment_category?: string;
  email?: string;
  referral_id?: number;
  is_pick_up?: string | boolean;
  group_invite_id?: number;
}): Promise<AResponse<IVirtualPay>> => {
  return fetch.post('/ec/so/order/nocart/checkout/v2', params);
};

export const miniMarketPay = (params: {
  product_type?: string;
  deal_id?: number;
  items: VirtualParams[];
  page_time?: number;
  points?: number;
  email?: string;
  phone?: string;
  payment_category?: string;
  referral_id?: number;
  pick_up_point_id?: number;
  radar_options?: { session: string };
  braintree_device_data?: string;
  cvv_token?: string;
}): Promise<AResponse<IVirtualPay>> => {
  return fetch.post('/ec/so/order/mini_market/checkout', params);
};

export const checkStoreInZipcode = (
  params: {
    zipcode: string | number;
    store_id: string | number;
    force: boolean;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.put('/ec/so/porder/zipcode/v2', params, config);
};

/**
 * 获取试用会员权限
 * @param config
 */
export const getVipTrial = (params: { keyword: string }, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/so/customer/free_trial', params, config);
};

/**
 * 获取曾经购买full info
 * @param config
 */
export const getBoughtInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/so/bought', params || {}, config);
};

/**
 * 切换送货地址
 */
export const changePorderAddress = (
  params?: { [key: string]: any },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.put('/ec/so/porder/address/v2', params, config);
};

/**
 * 切换送货地址v2
 */
export const changePorderAddressV2 = (
  params?: { [key: string]: any },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.put('/ec/so/address/apply/v2', params, config);
};

/**
 * 切换orderDetail送货地址
 */
export const changeShippingAddress = (
  params?: { [key: string]: any },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.put('/ec/so/address/order/update', params, config);
};
/**
 * 更新连续方式
 */
export const updateContactInfo = (
  params?: { [key: string]: any },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.put('/ec/so/porder/contact/pickup', params, config);
};

/**
 * 获取order-detail
 * @param params
 * @param config
 */
export const getOrderDetail = (orderId: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/view/order/${orderId}`, {}, config);
};

/**
 * Account-取消订单
 * @param params
 * @param config
 */
export const cancelOrder = (params, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/so/order/unpaid/cancel`, params, config);
};

/**
 * Account-物流跟踪
 * @param params
 * @param config
 */
export const getTrackInfo = (order_id, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/${order_id}/track_order`, config);
};

/**
 * Account-订单列表查询
 * @param params
 * @param config
 */
export const getOrderList = (params, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/so/order/query/listMyOrder/v2`, params, config);
};

/*
 * @param params 获取order-success页面数据
 * @param config
 */
export const getOrderDetails = (orderId, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/success/${orderId}`, {}, config);
};

/*
 * @param params 获取order-success页面数据v2
 * @param config
 */
export const getOrderDetailsV2 = (orderId, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/success/v2/${orderId}`, {}, config);
};

/**
 * 记录用户同意酒类协议的操作
 */
export const recordAlcoholAgree = (
  params?: { refer_type: 'normal' | 'seller' },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post(`/ec/so/porder/record/alcohol`, params, config);
};

/**
 *
 * @param params 获取dealpay的信息
 * @param config
 */
export const getDealpayInfo = (params?: {
  order_id: string;
  browser_type?: string;
  payment_routing?: string;
}): Promise<AResponse> => {
  return fetch.post(`/ec/so/order/query/deal/pay`, params);
};

/**
 *  v2版本
 * @param params 获取dealpay的信息
 * @param config
 */
export const getDealpayInfoV2 = (params?: { checkout_id: string; browser_type?: string }): Promise<AResponse> => {
  return fetch.post(`/ec/so/order/query/deal/pay/v2`, params);
};

/**
 * 查看支付状态接口
 * @param params
 * @param config
 */
export const checkOrderPaymentStatus = (
  params?: { order_id: string },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/status/v2`, params, config);
};

/**
 * v2 查看支付状态接口
 * @param params
 * @param config
 */
export const checkOrderPaymentStatusV2 = (
  params?: { order_ids?: number[] | string[] },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post(`/ec/so/order/query/status/v3`, params, config);
};

/**
 * 修改订单获取order detail
 * @param params
 * @param config
 */
export const getOrderModifyDetail = (orderId: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/modify_order_info/${orderId}`, {}, config);
};

/**
 * 修改订单接口
 * @param params
 * @param config
 */
interface ModifyOrderParams {
  order_id: number;
  comment: string;
  items: {
    product_id: number;
    quantity: number;
    id: number;
  }[];
  confirmed?: boolean;
}
export const modifyOrder = (params: ModifyOrderParams, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.put(`/ec/so/order/partial`, params, config);
};

/**
 * 取消小费接口
 * @param params
 * @param config
 */
export const cancelOrderTip = (order_id: number | string, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.put(`/ec/so/order/tip/${order_id}`, config);
};

/**
 * 整单取消接口
 * @param params
 * @param config
 */
interface CancelOrderParams {
  order_id: number;
  confirmed?: boolean;
  /** 来自 /ec/so/order/query/cancel/reason 列表项的 key */
  cancel_reason_key?: string;
  cancel_reason?: string;
  note?: string;
}
export const deleteOrder = (params: CancelOrderParams, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/so/order/all/cancel`, params, config);
};

/**
 * 虚拟结算pre接口 (mainly for points & group-ponts &  gift card)
 * @param param
 */
export const getVirtualCheckoutInfo = (
  params?: {
    product_type: string;
    items: VirtualParams[];
    deal_id?: number;
    member_share_id?: number;
    group_invite_id?: number;
    gift_card_info?: {
      theme_id?: number; // gift card theme
    };
    payment_routing?: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse<INoCartCheckoutPre>> => {
  return fetch.post('/ec/so/order/nocart/checkout/pre', params, config);
};

/**
 * 虚拟结算pre接口 (mainly for points & group-ponts &  gift card)
 * @param param
 */
export const getVirtualCheckoutInfoV2 = (
  params?: {
    product_type: string;
    items: VirtualParams[];
    deal_id?: number;
    member_share_id?: number;
    group_invite_id?: number;
    gift_card_info?: {
      theme_id?: number; // gift card theme
    };
    payment_routing?: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse<INoCartCheckoutPre>> => {
  return fetch.post('/ec/so/order/nocart/checkout/pre/v2', params, config);
};

/**
 *
 * @param param
 */
export const getMiniMarketCheckoutInfo = (
  params?: {
    product_type?: string;
    deal_id?: number;
    items?: VirtualParams[];
    payment_routing?: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse<INoCartCheckoutPre>> => {
  return fetch.post('/ec/so/order/mini_market/checkout/pre', params, config);
};

/**
 * dealpay获取跳转页面
 * @param params
 * @param config
 */
export const getOrderNextUrl = (params: {
  order_id: string;
  payment_category: string;
  platform: string;
  cvv_token?: string;
  radar_options?: { session: string };
  braintree_device_data?: string;
}): Promise<AResponse> => {
  return fetch.post(`/ec/so/order/query/category/next_url`, params);
};

/**
 * dealpay获取跳转页面 v2版本
 * @param params
 * @param config
 */
export const getOrderNextUrlV2 = (params: {
  checkout_id: string;
  payment_category: string;
  platform: string;
  cvv_token?: string;
  radar_options?: { session: string };
  braintree_device_data?: string;
}): Promise<AResponse> => {
  return fetch.post(`/ec/so/order/query/category/next_url/v2`, params);
};

/**
 * 获取订单信息
 * @param params
 * @param config
 */
export const getOrderPayInfo = (params?: { order_id: string }): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/payLoading/info`, params);
};

/**
 * v2 获取订单信息
 * @param params
 * @param config
 */
export const getOrderPayInfoV2 = (params?: { checkout_id: string }): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/payLoading/info/v2`, params);
};

/**
 * v3 获取订单信息v2->v3
 * @param params
 * @param config
 */
export const getOrderPayInfoV3 = (params?: { checkout_id: string; tx_id: string }): Promise<AResponse> => {
  return fetch.post(`/ec/so/order/query/payLoading/info/v3`, params);
};

/*
 * 新增、编辑用户地址V2
 * @param params
 * @param config
 */
export const submitUserAddress = (params): Promise<AResponse> => {
  return fetch.post(`/ec/so/address`, params);
};

/*
 * 删除地址
 * @param params
 * @param config
 */
export const deleteAddress = (addressId: string, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.delete(`/ec/so/address/${addressId}`, config);
};

/**
 * java 再来一单
 * @param params
 * @param config
 */
export const getOrderBuyAgain = (params, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/buyAgain/info/v2`, params, config);
};
/*
 * 获取H5今日订单信息
 * @param config
 */
export const getTodayOrderList = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/today_orders`, config);
};

/**
 * 移除购物车中赠品 不返回商品列表
 * @param config
 */
export const cartDeleteGift = (params?: any): Promise<AResponse> => {
  return fetch.delete(`/ec/so/activity/gift/cart/delete`, { data: params });
};

/**
 * 移除购物车中指定赠品V2
 * @param config
 */
export const cartDeleteGiftV2 = (params: {
  cart_domain: string;
  giftDeleteRequests: { gifts: any; vendor_id?: number; business_type?: string }[];
}): Promise<AResponse> => {
  return fetch.post(`/ec/so/activity/gift/cart/delete/v2`, params);
};

/** gift card order success */
export const getGiftCardOrderSuccess = (orderId, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/nocart/giftcard/success/${orderId}`, {}, config);
};

/** 拼团订单成功页 */
export const getPointsOrderSuccess = (orderId, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/nocart/point/success/${orderId}`, {}, config);
};

/** 拼团进度页 */
export const getPointsOrderView = (orderId, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/groupbuy/point/view/${orderId}`, {}, config);
};

/** 再次发起拼团 */
export const reactivePointsGbuy = (orderId, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/so/groupbuy/point/reactive/${orderId}`, {}, config);
};

/**
 * member success
 */
export const orderMemberSuccess = (params, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/nocart/member/success/${params.order_id}`, {}, config);
};

// get points group buy list
export const getPointsGroupBuyList = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/so/groupbuy/point/list', {}, config);
};

// reactivate points group buy
export const reactivatePointsGroupBuy = (orderId: string, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/so/groupbuy/point/reactive/${orderId}`, {}, config);
};

// 获取整单售后原因列表
export const getOptionsList = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/cancel/reason`, {}, config);
};

/** 删除账号操作日志接口 */
export const accountDeletionStep = (
  data: {
    causeId?: number | null;
    causeOther?: string | null;
    type?: 'popup_confirm ' | 'question_confirm ' | 'success_loading';
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post('/ec/customer/account/account_deletion_step', data, config);
};
/** 删除账号landing页面接 */
export const accountDeletionLoading = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/customer/account/account_deletion_loading', {}, config);
};
/** 删除账号操作接口 */
export const accountDeletion = (userId: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/customer/account/account_deletion', { userId }, config);
};

/** 地址adjust/pin校验 */
export const adjustPin = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/so/address/adjust/pin ', params, config);
};

// 获取order invoice信息
export const getOrderInvoice = (
  invoice_id: string,
  params: ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/invoice/${invoice_id}`, params, config);
};

/** VIP页面判断有没有点过通知按钮 */
export const detectVipNotifyStatus = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/customer/member/new_member_noti', {}, config);
};

/** VIP页面点击通知 */
export const vipStatusNotify = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/customer/member/new_member_noti', {}, config);
};

/**
 * 查询是否可以退款
 * @param {number} orderId 订单id
 */
export const refundVerify = (orderId: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/product/${orderId}/refund_verify`, {}, config);
};

/**
 * 订单列表，详情页面确认收货
 * @param {number} orderId 订单id
 */
export const orderConfirmReceipt = (orderId: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.put(`/ec/so/order/confirm_receipt/${orderId}`, {}, config);
};

/**
 * 凑单活动页面获取的购物车信息
 * @param params
 * @param config
 * @returns
 */
export const getPorderInfoByV4 = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/porder/v4`, params, config);
};

/**
 * 接口迁移，获取用户地址列表
 * @param params
 * @param config
 * @returns
 */
export const getUserAddressList = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/address/list`, params, config);
};

/**
 * 合单banner信息
 * @param config
 * @returns
 */
export const getCombineInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/combine_free_shipping_banner`, params, config);
};

/**
 * 订单列表合单更新porder
 * @param params
 * @param config
 * @returns
 */
export const updatePorderApply = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.put(`/ec/so/porder/apply_with_order_id/${params.order_id}`, {}, config);
};

/**
 * 获取冷链免邮门槛
 * @param params
 * @param config
 * @returns
 */
export const getColdPackageFee = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/config/cold_package_fee`, {}, config);
};

/**
 *
 * @param params 获取coupon信息
 * @param config
 * @returns
 */
export const getCheckoutCouponList = (
  params?: {
    cart_domain: 'grocery' | 'restaurant';
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/so/coupons/list/v2?cart_domain=${params.cart_domain || 'grocery'}`, {}, config);
};

/**
 * redeemCoupon
 * 通过tracking_code获取invoice信息
 * @param params
 * @param config
 * @returns
 */
export const getInvoiceByTrackingCode = (
  params: { code: string },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/so/order/query/invoice/package/${params.code}`, {}, config);
};

/**
 * 获取float cart信息
 * @param params
 * @param config
 * @returns
 */
export const redeemCoupon = (
  params?: {
    cart_domain: 'grocery' | 'restaurant';
    coupon_code: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post(`/ec/so/coupons/redeem`, params, config);
};

/**
 * float cart 商品增删改查
 * @param params
 * @param config
 * @returns
 */
export const getMkplFloatCart = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/seller/cart/float`, params, config);
};

/**
 * 获取float cart v2信息
 * @param params
 * @param config
 * @returns
 */
export const getMkplFloatCartV2 = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/seller/cart/float/v2`, params, config);
};
/**
 * float cart 商品增删改查
 * @param params
 * @param config
 * @returns
 */
export const mkplBuyItems = (
  vendor_id: number,
  params: ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.put(`/ec/so/seller/items/v2?vendor_id=${vendor_id}`, params, config);
};

export const applyCoupon = (
  params?: {
    cart_domain: 'grocery' | 'restaurant';
    coupon_code: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post(`/ec/so/coupons/apply/v2`, params, config);
};

/**
 * 首次获取shop page tag info
 * @param params
 * @param config
 * @returns
 */
export const queryShopMoreInfo = (
  params?: ObjectType & {
    shop_more_type?: ShopMoreType;
    ref_value?: string;
    refer_value?: string;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post(`/ec/so/porder/shop_more/tag`, params, config);
};

/**
 * 加购更新shop page tag info
 * @param params
 * @param config
 * @returns
 */
export const updateShopMoreInfo = (
  params?: {
    shop_more_type?: ShopMoreType;
    ref_value?: string;
    items?: ObjectType;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  const { shop_more_type, ref_value, items } = params;
  return fetch.put(
    `/ec/so/porder/items/activity?shop_more_type=${shop_more_type}&ref_value=${ref_value || null}`,
    items,
    config
  );
};

/**
 * 分类页获取68换购进度条数据接口
 */

export const getUpsellTagInfo = (
  data: { source: string; refer_type: string },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post('/ec/so/porder/trade_in/tag', data, config);
};

/**
 * 获取pre sale可修改配送日期的订单
 */
export const getPreChangeDateList = (params: ObjectType, config?: NewAxiosRequestConfig) => {
  return fetch.get('/ec/so/delivery_date/order/list', params, config);
};

/**
 * 获取pre sale可修改配送日期信息
 */
export const getPreChangeDateDetail = (params: ObjectType, config?: NewAxiosRequestConfig) => {
  return fetch.get('/ec/so/delivery_date/order/detail', params, config);
};

/**
 * 获取已购买商品列表数据
 */
export const getBoughtProductsList = (
  params: {
    delivery_date: string;
    zipcode: string;
  },
  config?: NewAxiosRequestConfig
) => {
  return fetch.get('/ec/so/order/query/purchased/products', params, config);
};

/**
 * 修改pre sale订单配送日期
 */
export const changeOrderDeliveryDate = (
  params: { order_id: string; delivery_date: string },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post('/ec/so/order/delivery_date/change', params, config);
};

export const getCartActivity = (
  params: { activity_type: string; refer_type: string },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post('/ec/so/porder/cart/activity', params, config);
};

/**
 * case商品申请退款
 */
export const refundProduts = (param: Object, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/so/order/query/return/products', param, config);
};

/**
 *  获取所有的支付列表
 */
export const getPaymentMethods = (param: Object, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/so/payment/getPaymentMethods', param, config);
};

/**
 *  获取EBT token
 */
export const getEbtToken = (channelCode: string, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/payment/v3/token/generate/${channelCode}`, {}, config);
};

/**
 *  获取EBT merchant
 */
export const getEbtMerchant = (channelCode: string, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/payment/v3/environment/${channelCode}`, {}, config);
};

/**
 *  删除EBT card
 */
export const deleteEbtCard = (params?: { profile_id: string }, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.delete(`/ec/payment/ebt/profile/${params.profile_id}`, config);
};

/**
 *  升级支付接口
 */
export const checkoutV4 = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/so/order/checkout/v4', {}, config);
};

/**
 *  获取订阅列表
 */
export const getSubscribeList = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/so/subscribe/delivery/list', {}, config);
};

/**
 *  获取订阅商品列表（Subscriptions tab）
 */
export const getSubscribeSubscriptionList = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/so/subscribe/subscription/list', {}, config);
};

/**
 *  获取订阅行详情（subscription）
 * @param params user_subscribe_id 订阅行主键
 */
export const getSubscribeSubscriptionDetail = (
  params: { user_subscribe_id: number },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/so/subscribe/subscription/detail', params, config);
};

/**
 * 订阅行「下次配送」可选计划列表（弹窗选项）
 */
export const getSubscribePlanDeliveryOptions = (
  params: { user_subscribe_id: number },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/so/subscribe/subscription/plan-delivery-options', params, config);
};

/**
 * 获取订阅行可选支付方式列表
 * @param params user_subscribe_id 订阅行主键
 */
export const getSubscribeSubscriptionPaymentMethods = (
  params: { user_subscribe_id: number },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/so/subscribe/subscription/payment_methods', params, config);
};

/**
 * 获取订阅行可选地址列表
 * @param params user_subscribe_id 订阅行主键
 */
export const getSubscribeSubscriptionAddressList = (
  params: { user_subscribe_id: number },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/so/subscribe/subscription/address/list', params, config);
};

/**
 *  获取订阅详情
 */
export const getSubscribeDetail = (param: Object, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/so/subscribe/delivery/detail', param, config);
};

/**
 *  获取订阅详情
 */
export const getSubscribeDetailNext = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/so/subscribe/delivery/next', {}, config);
};

/**
 * 获取订阅信息接口
 * @param params
 * @param config
 * @returns
 */
export const getSubscribeCycleList = (id: number, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/so/subscribe/plan/list/${id}`, {}, config);
};

/**
 * 更新订阅信息接口
 * @param params
 * @param config
 * @returns
 */
export const updateSubscribeInfo = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/so/subscribe/product/setup`, params, config);
};

/**
 * 跳过订阅接口
 * @param params
 * @param config
 * @returns
 */
export const skipSubscribe = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/so/subscribe/product/skip`, params, config);
};

/**
 * 取消订阅接口
 * @param params
 * @param config
 * @returns
 */
export const cancelSubscribe = (params: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(`/ec/so/subscribe/product/cancel`, params, config);
};

/**
 * 设置订阅
 */
export const setSubscribeProduct = (params: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/so/subscribe/product/setup', params, config);
};

/**
 * 变更/删除地址，订阅计划校验
 */
export const checkSubscribeAddress = (params: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/so/subscribe/checkAddress', params, config);
};

/**
 * 删除支付方式，订阅计划校验
 */
export const checkSubscribePayment = (params: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/so/subscribe/checkCard', params, config);
};

export interface GetFloatingCartParams {
  cart_domain: string; // default: grocery
  cart_id: string; // pantry
}

export const getFloatingCartData = (params: GetFloatingCartParams) => {
  return fetch.get<FloatingCartResponse>('/ec/so/porder/cart/float', params);
};

/**
 * 确认/切换订阅合并状态
 */
export const confirmCombineSubscriptionStatus = (params: any, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/so/subscribe/combine/confirm', params, config);
};

export const getShippingFeePopup = (params: Record<string, any>): Promise<AResponse> => {
  return fetch.post('/ec/so/porder/cart/shipping_fee_popup', params);
};
